import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Process} from '../../_models/process';
import {ConfigStub} from "../../_typing/config-stub";
import {BeforeSaveAction} from "../../_typing/utils/before-save";
import {NotificationService} from "../../services/notification.service";
import {EXTENDED_NOTIFICATION_DURATION_MS} from "../../shared/globals";
import {
    SelectSearchComponentComponent
} from "../../components/select-search-api/single/select-search-component.component";
import {COMMON_FORM_IMPORTS} from "../../shared/import-groups/Common";
import {MatHint} from "@angular/material/form-field";

export interface FlowchartConfig {
    process: ConfigStub<Process>;
    scale: number;
    left_offset: number;
    top_offset: number;
}

@Component({
    selector: 'flowchart-tile-form',
    templateUrl: 'flowchart-tile-form.component.html',
    imports: [
        SelectSearchComponentComponent,
        COMMON_FORM_IMPORTS,
        MatHint
    ],
    styleUrls: ['flowchart-tile-form.component.scss']
})
export class FlowchartTileFormComponent implements OnInit, BeforeSaveAction {

    @Input() config: FlowchartConfig;

    @Input() hideScroll: boolean = false;
    @Output() hideScrollChange = new EventEmitter<boolean>();

    constructor(private notification:NotificationService) {
    }

    ngOnInit() {
    }

    onProcessChange(process: Process) {
        this.config.process = new ConfigStub(process);
    }

    onHideScrollChange($event) {
        this.hideScrollChange.emit($event.checked);
    }

    beforeSave(): boolean {
        if (this.config.process?.id) {
            return true;
        }
        this.notification.openError("You must select a process.", EXTENDED_NOTIFICATION_DURATION_MS, "Hide");
        return false;
    }
}
